import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import moment from 'moment';

import api from './api';
import HttpStatus from 'http-status';

const TIMEOUT = ((60 * 1000) * 60) * 8;

export default function useAuth() {

  const navigate = useNavigate();

  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  const clearLocalStorageData = () => {
    setAuthenticated(false);
    setLoading(false);
    localStorage.removeItem('token');
    localStorage.removeItem('login');
    localStorage.removeItem('profile');
    localStorage.removeItem('avatar');
    localStorage.removeItem('userid');
    localStorage.removeItem('firstname');
    localStorage.removeItem('lastname');
    localStorage.removeItem('companyid');
    localStorage.removeItem('company');
    localStorage.removeItem('companylogo');
    localStorage.removeItem('companylogowidth');
    localStorage.removeItem('companylogoheigth');
    localStorage.removeItem('deviceid');
    localStorage.removeItem('userexternalid');
    localStorage.removeItem('authenticateDevice');
    api.defaults.headers.Authorization = undefined;
  }

  const expirar = () => {
    clearLocalStorageData()
  }

  const clock = () => {
    if (window.document.getElementById('clock')) {
      var tm = moment().format('DD/MM/YYYY HH:mm:ss')
      window.document.getElementById('clock').innerHTML = tm
    }
    setTimeout(clock, 1000);
  }

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;
        setAuthenticated(true);
        setLoading(false);
      } catch (error) {
        clearLocalStorageData();
      }
    } else {
      if (!localStorage.getItem('authenticateDevice')) {
        navigate('/login', { replace: true });
        setLoading(true);
      }
    }
  }, [authenticated, loading]);

  async function handleLogin(values) {
    await api.post('/login', { login: values.login, password: values.password }, {
    }).then((response) => {
      if (response.status === HttpStatus.OK) {
        var token = response.data.token;
        var user = response.data.user;
        localStorage.setItem('token', JSON.stringify(token));
        localStorage.setItem('login', user.login);
        localStorage.setItem('profile', user.profile);
        localStorage.setItem('avatar', user.avatar);
        localStorage.setItem('userid', user._id);
        localStorage.setItem('firstname', user.firstname);
        localStorage.setItem('lastname', user.lastname);
        localStorage.setItem('companyid', user.company._id);
        localStorage.setItem('company', user.company.name + ' - ' + user.company.detail);
        localStorage.setItem('companylogo', user.company.logo.image);
        localStorage.setItem('companylogowidth', user.company.logo.width);
        localStorage.setItem('companylogoheigth', user.company.logo.heigth);
        localStorage.setItem('deviceid', '');
        localStorage.setItem('userexternalid', (!user.externalid || user.externalid == -1) ? 99999999 : user.externalid);
        localStorage.removeItem('authenticateDevice');
        api.defaults.headers.Authorization = `Bearer ${token}`;
        setAuthenticated(true);
        setTimeout(expirar, TIMEOUT);
        setTimeout(clock, 1000);
        if (user.profile == 'AST') {
          navigate('/sup/supports', { replace: true });
        } else if (user.profile == 'ENG') {
          navigate('/cfg/main', { replace: true });
        } else if (user.profile == 'ADM') {
          navigate('/adm/main', { replace: true });
        } else if (user.profile == 'AAD') {
          navigate('/mgt/main', { replace: true });
        } else {
          navigate('/mon/main', { replace: true });
        }
      } else {
        clearLocalStorageData
      }
    }).catch((error) => {
      clearLocalStorageData
    })
  }

  function handleLogout() {
    clearLocalStorageData
    navigate('/login', { replace: true });
  }

  return { authenticated, loading, handleLogin, handleLogout };
}